import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import { Link } from "react-router-dom"
import { useEffect } from "react"
import ImageSliderItem from "./common/ImageSliderItem"

const Citizens = () => {

    useEffect(() => {
        document.title = 'Séneca - Ciudadanos'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="h100 w100 flex col jcenter mtminus100">

            <section className="w100 flex col acenter jcenter">

                <ImageTitleItem
                    imageURL="/images/citizens/ciudadanos-1.jpg"
                    imageURLMobile="/images/citizens/ciudadanos-1m.jpg"
                    titleText="Participa desde la mejor tribuna"
                    icon="bi bi-people-fill blue-icon"
                    subtitleText="Séneca te da acceso a los debates de tu institución desde cualquier dispositivo: síguelos en directo, bajo demanda, y comparte lo que más te importa."
                />

                <SliderImageSeparator />

                <ImageSliderItem
                    imagePosition="before"
                    layout="row"
                    size="normal"
                    animated={true}
                    imageArray={[
                        "/images/citizens/citizens-devices-01.png",
                        "/images/citizens/citizens-devices-02.png",
                        "/images/citizens/citizens-devices-03.png"
                    ]}
                    title="Cuando quieras, desde donde quieras"
                    textArray={[
                        "<p class='middle-section-label'><strong>Séneca proporciona acceso a las sesiones, tanto en directo como bajo demanda, desde cualquier dispositivo y ubicación.</strong></p>",
                        "<p class='middle-section-label'>Sigue la sesión cuando tengas tiempo, accede directamente a cualquier intervención y busca por tema, orador o palabras pronunciadas. Comparte momentos del debate en tus redes y comenta tu punto de vista. Si te registras, podrás seguir a los oradores que más te interesen y ver sus últimas intervenciones al entrar.</p>"
                    ]}
                modern="true"
                />

                <SeparatorLine />

                <ImageSectionItem
                    imagePosition="before"
                    layout="row"
                    imageURL="/images/citizens/ciudadanos-3.jpg"
                    title="La transparencia de tus representantes"
                    textArray={[
                        "<p class='middle-section-label'><strong>Séneca hace visible el trabajo de tus representantes y te permite consultar sus intervenciones filtrando por órgano, temática o período.</strong></p>",
                        "<p class='middle-section-label'>Crea tu perfil, marca como favoritos a los oradores que más te interesen y accede directamente a sus últimas intervenciones cada vez que entres.</p>"
                    ]}
                modern="true"
                />

                <SeparatorLine />

                <ImageSectionItem
                    imagePosition="before"
                    layout="row"
                    imageURL="/images/citizens/ciudadanos-4.jpg"
                    title="Búsquedas, también por voz"
                    textArray={[
                        "<p class='middle-section-label'><strong>Quién, cuándo, dónde y qué dijo. Cualquier pregunta, o todas juntas, respondidas por Séneca de forma inmediata.</strong></p>",
                        "<p class='middle-section-label'>Busca por categorías, oradores, legislaturas… o directamente por las palabras que se pronunciaron.</p>",
                        "<p class='middle-section-label'>Séneca vincula automáticamente cada palabra con el instante exacto del vídeo en que se pronunció, lo que permite comparar cómo distintos oradores han tratado un mismo tema a lo largo del tiempo.</p>"
                    ]}
                modern="true"
                />

                <SeparatorLine />

                <ImageSectionItem
                    imagePosition="before"
                    layout="row"
                    imageURL="/images/citizens/ciudadanos-5.gif"
                    title="Comparte lo que importa"
                    textArray={[
                        "<p class='middle-section-label'><strong>Séneca te permite compartir las intervenciones más relevantes manteniendo su contexto. Señala un momento del debate y publícalo, coméntalo o critícalo en tu red social preferida.</strong></p>",
                        "<p class='middle-section-label'>Quien lo vea podrá escuchar la pregunta, la respuesta y la réplica completa, sin recortes y sin intermediarios.</p>"
                    ]}
                modern="true"
                />

                <SeparatorLine />

                <ImageSectionItem
                    imagePosition="before"
                    layout="row"
                    imageURL="/images/citizens/ciudadanos-6.jpg"
                    title="Mucho más que vídeo"
                    textArray={[
                        "<p class='middle-section-label'><strong>Séneca no es solo una videoteca.</strong> Junto a cada grabación encontrarás archivos de texto, imágenes y datos vinculados a la sesión: el diario de sesiones completo, material gráfico y las notas de prensa del gabinete institucional, todo descargable.</p>"
                    ]}
                modern="true"
                />

            </section>

            <section className="main-cta-section">
                <h2 className="main-cta-title">¿Quieres saber más?</h2>
                <p className="main-cta-desc">Contacta con nosotros y te explicamos cómo Séneca puede acercar tu institución a la ciudadanía.</p>
                <Link to="/contacto" className="main-cta-button">Solicitar información</Link>
            </section>

        </main>
    )

}

export default Citizens
